import { Injectable } from '@angular/core';
import { Observable, of, combineLatest } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { UrlBuilder } from '../../core';
import { NavigationServiceLink } from './../service/navigation-service/navigation-service-link';
import { ReportsStorageService } from '../reports/services/reports-storage-service';
import { SampleMonitoringStorage } from '../sample-monitoring/service/sample-monitoring-storage';

@Injectable()
export class SampleTrackingLinksInfoStorage {

    public get all() {
        return this.sampleTrackingLinksInfo;
    }

    public sampleTrackingLinksInfo: Observable<NavigationServiceLink[]>;
    public newReportCount: Observable<number>;

    private readonly sampleTrackingLink = this.urlBuilder
        .esa()
        .sampletracking()
        .home()
        .url();

    private readonly sampleAliquotesLink = this.urlBuilder
        .esa()
        .sampletracking().sampleAliquots().url();

    private readonly sampleMonitoringLink = this.urlBuilder
        .esa()
        .sampletracking()
        .sampleMonitoring()
        .notifications()
        .url();

    private readonly reportsLink = this.urlBuilder
        .esa()
        .sampletracking()
        .report()
        .home()
        .url();

    private readonly preferenceLink = this.urlBuilder
        .esa()
        .sampletracking()
        .preference()
        .url();

    constructor(private urlBuilder: UrlBuilder,
                private reportsStorage: ReportsStorageService,
                private monitoringStorage: SampleMonitoringStorage,
    ) {
        this.sampleTrackingLinksInfo = combineLatest([
            this.reportsStorage.reportCount, this.monitoringStorage.notificationCount
        ])
            .pipe(
                map(([newReportCount, notificationCount]) => this.getLinks(newReportCount, notificationCount)),
                publishReplay(1),
                refCount()
        );
    }

    private getLinks(reportCount: number, notificationCount: number) {
        const links: NavigationServiceLink[] = [];
        const newNotificationDisplayCount = notificationCount > 0 ? notificationCount.toString() : null;
        const reportDisplayText = reportCount > 0 ? 'New' : null;
        let badgeToolTip = reportCount > 0 ? 'You have new reports available!' : null;
        let smToolTip = notificationCount > 0 ? 'You have ' + notificationCount + ' new sample monitoring notifications!' : null;
        links.push(new NavigationServiceLink('My Portfolio', of(this.sampleTrackingLink), null, null, null, of(false), '', true, 'images/sample_tracking/ic_home.svg'));
        links.push(new NavigationServiceLink('Samples & Aliquots', of(this.sampleAliquotesLink), null, null, null, of(true), '', true, 'images/sample_tracking/ic_dashboard.svg'));
        links.push(new NavigationServiceLink('Reports', of(this.reportsLink), null, of(reportDisplayText), null, of(false), '', true, 'images/sample_tracking/ic_report.svg', badgeToolTip));
        links.push(new NavigationServiceLink('My Preferences', of(this.preferenceLink), null, null, null, of(false), '', true, 'images/sample_tracking/ic_setting.svg'));
        links.push(new NavigationServiceLink('Sample Monitoring', of(this.sampleMonitoringLink), null, of(newNotificationDisplayCount), null, of(false), '', true, 'images/sample_tracking/ic-bell.svg', smToolTip));
        return links;
    }
}